module.exports = __webpack_public_path__ + "static/media/img_practiseguro@2x.2397f2db.png";